import React, { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useLoyaltyProfile } from '@/hooks/useLoyaltyProfile';
import Layout from '@/components/layout/Layout';
import ClubLogin from '@/components/club/ClubLogin';
import ClubDashboard from '@/components/club/ClubDashboard';
import { Loader2 } from 'lucide-react';

const Club = () => {
  const { user, loading: authLoading } = useAuth();
  const { profile, loading: profileLoading } = useLoyaltyProfile();
  const [registrationSource, setRegistrationSource] = useState<string | null>(null);

  // Track registration source from URL params
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const origen = params.get('origen');
    if (origen) {
      setRegistrationSource(origen);
      // Store in sessionStorage for use during registration
      sessionStorage.setItem('club_registration_source', origen);
    }
  }, []);

  if (authLoading) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <Loader2 className="h-12 w-12 animate-spin text-secondary mx-auto mb-4" />
            <p className="text-muted-foreground">Cargando...</p>
          </div>
        </div>
      </Layout>
    );
  }

  // Not logged in - show login/register form
  if (!user) {
    return <ClubLogin registrationSource={registrationSource} />;
  }

  // Logged in but profile still loading
  if (profileLoading) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <Loader2 className="h-12 w-12 animate-spin text-secondary mx-auto mb-4" />
            <p className="text-muted-foreground">Cargando tu perfil de socio...</p>
          </div>
        </div>
      </Layout>
    );
  }

  // Logged in - show dashboard
  return <ClubDashboard />;
};

export default Club;
